var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMachineLearningOptimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "#3282FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.695 1.531a.744.744 0 0 0-.491.395c-.06.145-1.637 7.761-1.637 7.902 0 .29.255.58.563.638.099.019.664.034 1.258.034.593 0 1.079.012 1.079.026 0 .014-.263 1.538-.584 3.385-.32 1.848-.583 3.401-.583 3.451 0 .154.156.422.307.526.12.083.167.095.379.095.216 0 .256-.01.378-.1.167-.122 7.716-8.817 7.805-8.99.193-.372-.054-.868-.476-.958-.104-.022-.942-.035-2.311-.035-1.182 0-2.149-.006-2.149-.013 0-.008.758-1.227 1.685-2.709.926-1.482 1.7-2.753 1.719-2.825.073-.27-.069-.591-.33-.744l-.157-.092-3.167-.005c-1.741-.003-3.221.006-3.288.019m5.738.982c0 .008-.758 1.227-1.684 2.709-.926 1.482-1.7 2.753-1.719 2.825-.073.27.069.591.329.744l.158.092 2.194.01c1.206.005 2.189.021 2.183.035-.035.083-6.412 7.39-6.421 7.356-.005-.022.225-1.389.512-3.037.353-2.032.516-3.044.505-3.142-.021-.19-.169-.399-.358-.505l-.149-.083-1.193-.011c-1.099-.01-1.192-.015-1.177-.067.008-.03.332-1.586.72-3.456.387-1.87.71-3.418.718-3.441.011-.033.58-.042 2.698-.042 1.476 0 2.684.006 2.684.013",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMachineLearningOptimize);
export default __webpack_public_path__ + "static/media/icon-machineLearningOptimize.0122de92aeb992b5d1886b4b2d3dc543.svg";
export { ForwardRef as ReactComponent };